import React from 'react';

const WHATSAPP_NUMBER = '51956567391';
const DEFAULT_MESSAGE = 'Hola nasca360.com, me gustaría más información sobre la experiencia.';

const WhatsAppButton = () => {
  const handleClick = (e) => {
    e.preventDefault();
    const text = encodeURIComponent(DEFAULT_MESSAGE);
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
    const isMobile = /iPhone|iPad|iPod|Android/i.test(ua);
    // Mobile -> opens the app directly (wa.me also works but redirects via api.whatsapp.com)
    // Desktop -> goes straight to WhatsApp Web, skipping api.whatsapp.com which may be blocked
    const url = isMobile
      ? `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`
      : `https://web.whatsapp.com/send?phone=${WHATSAPP_NUMBER}&text=${text}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}`}
      onClick={handleClick}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Contáctanos por WhatsApp"
      className="fixed bottom-6 left-6 z-[9998] group"
    >
      <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-30"></span>
      <span className="relative flex items-center justify-center w-14 h-14 bg-[#25D366] hover:bg-[#1ebe57] rounded-full shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-110">
        <svg
          viewBox="0 0 32 32"
          className="w-7 h-7 fill-white"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.515 2.478-1.318.158-.43.158-.802.115-.918-.072-.214-.272-.272-.586-.43-.272-.157-2.005-.985-2.106-.985zM16.5 7.85c-4.764 0-8.677 3.913-8.677 8.677 0 1.476.36 2.92 1.047 4.227l-1.10 4.064 4.18-1.075a8.625 8.625 0 0 0 4.56 1.288c4.764 0 8.677-3.913 8.677-8.677S21.264 7.85 16.5 7.85zm0 15.91a7.21 7.21 0 0 1-3.798-1.075l-.272-.158-2.578.674.687-2.522-.158-.272a7.193 7.193 0 0 1-1.16-3.913c0-4.005 3.275-7.28 7.28-7.28s7.28 3.275 7.28 7.28-3.275 7.266-7.28 7.266z"/>
        </svg>
      </span>
      <span className="absolute left-16 top-1/2 -translate-y-1/2 bg-amber-900 text-white text-sm font-medium px-3 py-1.5 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none shadow-lg">
        ¿Hablamos por WhatsApp?
      </span>
    </a>
  );
};

export default WhatsAppButton;
